/**
 * AI を使う（今月の利用量が減る）操作に付ける印
 *
 * 用途のボタン・AI を呼ぶ最後の段・観点や調子の直し・次の一手・「AIに聞く」・送信ボタンに付ける。
 * AI を使わない操作（確定・取り消し・サーバーが組む変更案・画面の切り替え）には付けない。
 */

import { SparklesIcon } from '@heroicons/react/24/solid';

const AI_MARK_LEGEND = 'が付いた操作はAIを使い、今月の利用量が減ります';

export default function AiMark({ className = 'text-primary-500' }: { className?: string }) {
  return (
    <>
      <SparklesIcon
        aria-hidden="true"
        className={`inline-block h-3.5 w-3.5 flex-none align-[-2px] ${className}`}
      />
      <span className="sr-only">（AIを使います）</span>
    </>
  );
}

/** 「✨ が付いた操作は…」の一行 */
export function AiMarkLegend({ className = '' }: { className?: string }) {
  return (
    <p className={`flex items-center gap-1 text-[11px] text-text-500 ${className}`}>
      <SparklesIcon aria-hidden="true" className="h-3.5 w-3.5 flex-none text-primary-500" />
      {AI_MARK_LEGEND}
    </p>
  );
}
